import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/relationships";

export const Route = createFileRoute("/admin/_list-master/relationships")({
  component: Page,
});
